import {CsvWriter} from "./CsvWriter"
import {transformTableFieldValueToString} from "../transformTableFieldValueToString"

export class ExportItems {
  #data = []
  #fields = []
  #dataRows = []
  #headerRows = []
  #format = null

  /**
   * @param data
   * @returns {ExportItems}
   */
  setData (data = []) {
    this.#data = data
    return this
  }

  /**
   * @param data
   * @returns {ExportItems}
   */
  appendData (data = []) {
    this.#data = [...this.#data, ...data]
    return this
  }

  /**
   * @param fields
   * @returns {ExportItems}
   */
  setFields (fields = {}) {
    this.#fields = fields
    return this
  }

  /**
   * @param format
   * @returns {ExportItems}
   */
  setFormat (format = '') {
    this.#format = format
    return this
  }

  #convertDataToRows() {
    this.#dataRows = []
    this.#data.forEach(item => {
      const row = [item.id || '']
      for (let fName in this.#fields) {
        row.push(
          transformTableFieldValueToString(
            item,
            fName,
            this.#fields[fName]
          )
        )
      }
      this.#dataRows.push(row)
    })
  }

  #createHeader () {
    this.#headerRows = ['id']
    for (let fName in this.#fields) {
      this.#headerRows.push(this.#fields[fName].label)
    }
  }

  async toFile (fileName) {
    if (this.#format === 'csv') {
      return this.toCSV(fileName)
    }
    throw new Error(`Unsupported format ${this.#format}`)
  }

  async toCSV (fileName = 'data') {
    this.#createHeader()
    this.#convertDataToRows()
    let csvWriter = new CsvWriter()
    const byteArr = await csvWriter.serialize([
      this.#headerRows,
      ...this.#dataRows
    ])
    csvWriter = null
    return new File([byteArr], `${fileName}.csv`, {type: 'text/csv;charset=windows-1251;'})
  }
}
